var _path, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarnes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#db6d9d",
    d: "M97 72v-1h-5l-1 1v1H31v-5H16v-9H0V40a8557 8557 0 0 1 15-1l1-3v-4h13v-7h-9v-8h9V0h35v6h1a10453 10453 0 0 1 59-2h1v9h18v20h-7v-3l-1-3h-4l-4-1v47h-8l-1-1-1-1h-5v2H97z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 32,
    fill: "#db6d9d",
    fontFamily: "Arial",
    fontSize: 19,
    fontWeight: 300,
    style: {
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "center"
    },
    textAnchor: "middle"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 74,
    y: 32,
    fill: "#ffffff"
  }, "Barnes")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 74,
    y: 55,
    fill: "#ffffff"
  }, "Building"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarnes);
export default __webpack_public_path__ + "static/media/Barnes.5a38b22aedc1185c9717b78d30d181b1.svg";
export { ForwardRef as ReactComponent };